module.exports = __webpack_public_path__ + "static/media/instagram-dark.991b3893.svg";